<template>
<div class="view">
	
	<box :label="'Min arbejdstid seneste uge: '+ my_timelogs_this_week_hrs +' t.'">

		<table class="table-timespan-dates">
			<tr>
				<th v-for="(entry,i) in weekTimelogs_timespan" :data-day="entry.dayno" :key="'affds'+i">
					<span class="l1">{{entry.date.format('ddd')}}</span>
					<span class="l2">{{entry.date.format('D/M')}}</span>
				</th> 
			</tr>
			<tr>
				<td v-for="(entry,i) in weekTimelogs_timespan" :data-day="entry.dayno" :key="'afds'+i">
					<span class="l1">{{entry.hours_logged}}</span>
					<span class="l2">timer</span>
					<div class="bar" :style="barHeight( entry.hours_logged, weekTimelogs_timespan_maxhours )"></div>
				</td>
			</tr>
		</table>

	</box>

	<div class="grid">
		<div class="col m50">

			<box :label="'Min arbejdstid i dag: '+ my_timelogs_today_hrs +' t.'">

				<template slot="meta-r">
					<div class="textlink" @click="openTimelogger()">Log tid</div>
				</template>

				<table class="table-a timelogs-table">					
					<tr>
						<th></th>
						<th>Opgave</th>
						<th>Kunde</th>
						<th>Type</th>
						<th>Tid</th>
						<th></th>
						<th></th>
					</tr>				
					<tr v-for="(timelog,i) in my_timelogs_today" :key="'ads'+i">
						<td>
							<avatar :input="getOne('project',timelog.project_key)"></avatar>
						</td>
						<td v-if="getOne('project',timelog.project_key)">
							<router-link class="textlink" :to="'project/'+timelog.project_key">{{getOne('project',timelog.project_key).name}}</router-link>
						</td>
						<td v-if="getClientFromTimelog(timelog)">
							<router-link class="textlink" :to="'client/'+getOne('project',timelog.project_key).client_key">{{getClientFromTimelog(timelog).name}}</router-link>
						</td>
						<td>
							{{translateWorktype(timelog.worktype)}}
						</td>
						<td>
							{{timelog.hours}}
						</td>
						<td>
							<div class="textlink" @click="editTimelog(timelog)">
								<svgicon icon="linearicons/pencil"></svgicon>
							</div>
						</td>
						<td>
							<div class="textlink" @click="delete_timelog(timelog)">
								<svgicon icon="linearicons/trash"></svgicon>
							</div>
						</td>
					</tr>					
				</table>

				<div class="align-c" v-if="my_timelogs_today_invoicable_earning">
					<br>
					Indtjening: <b>{{ my_timelogs_today_invoicable_earning | money }} kr.</b>
				</div>

			</box>			

			<box v-if="is_user('wp')">WP todo: Vis economy nøgletal her i minibox.</box>		

			
			<masonry>

				<div class="masonry-grid-item w1 h1">
					<div class="snackbox clickable" @click="goto('clients')">
						<div class="m up">
							<svgicon icon="linearicons/rocket"></svgicon><br><br>
						</div>
						<div class="b">Kunder</div>
					</div>
				</div>


				<div class="masonry-grid-item w1 h1">
					<div class="snackbox clickable" @click="goto('timeline')">
						<div class="m up">
							<svgicon icon="ionicons/ios-calendar-outline"></svgicon><br><br>
						</div>
						<div class="b">Timeline</div>
					</div>
				</div>

				<div class="masonry-grid-item w1 h1">
					<div class="snackbox clickable" @click="goto('timelogs')">
						<div class="m up">
							<svgicon icon="linearicons/pie-chart"></svgicon><br><br>
						</div>
						<div class="b">Tidsforbrug</div>
					</div>
				</div>

				<div class="masonry-grid-item w1 h1">
					<div class="snackbox clickable" @click="openTimelogger()">
						<div class="m up">
							<svgicon icon="linearicons/pie-chart"></svgicon><br><br>
						</div>
						<div class="b">Log arbejdstid</div>
					</div>
				</div>


			</masonry>
			

		</div>
		<div class="col m50">

			<box label="Mine aktive projekter">
				<table class="table-a timelogs-table">				
					<tr>
						<th></th>
						<th>Opgave</th>
						<th></th>								
					</tr>				
					<tr v-for="(project,i) in myActiveProjects" :key="'fads'+i">
						<td><avatar :input="project"></avatar></td>
						<td>
							<router-link class="textlink" :title="project.client.name||'Ingen kunde'" :to="'project/'+project.key">{{project.name}}</router-link>
						</td>
						<td class="align-r">
							<div class="timelog-play-btn" @click="openTimeloggerBasic({project_key:project.key})"><svgicon icon="ionicons/ios-play"></svgicon></div>
						</td>
					</tr>				
				</table>
			</box>


			<box label="Alle aktive projekter" :open="false" header-toggle>
				<table class="table-a timelogs-table">					
					<tr>
						<th></th>
						<th>Opgave</th>
						<th></th>								
					</tr>				
					<tr v-for="(project,i) in allActiveProjects" :key="'fads'+i">
						<td><avatar :input="project"></avatar></td>
						<td>
							<router-link class="textlink" :title="project.client.name||'Ingen kunde...'" :to="'project/'+project.key">{{project.name}}</router-link>
						</td>
						<td class="align-r">
							<div class="timelog-play-btn" @click="openTimeloggerBasic({project_key:project.key})"><svgicon icon="ionicons/ios-play"></svgicon></div>
						</td>
					</tr>				
				</table>
			</box>
			
			
			<box label="Klar til fakturering">
				<table class="table-a timelogs-table">					
					<tr>
						<th></th>
						<th>Opgave</th>
						<th></th>								
					</tr>				
					<tr v-for="(project,i) in projects_invoice_ready" :key="'fads'+i">
						<td><avatar :input="project"></avatar></td>
						<td>
							<router-link class="textlink" :title="project.client.name||'Ingen kunde'" :to="'project/'+project.key">{{project.name}}</router-link>
						</td>
						<td class="align-r">
							{{ $store.getters['projects/get_payable_amount'](project) | money(2) }} kr.
						</td>
					</tr>				
				</table>
			</box>

			<box label="Skyldige betalinger">
				<table class="table-a timelogs-table">				
					<tr>
						<th></th>
						<th>Opgave</th>
						<th>Fakturering</th>								
						<th class="align-r">Beløb</th>
					</tr>				
					<tr v-for="(project,i) in projects_money_owed" :key="'fads'+i">
						<td><avatar :input="project"></avatar></td>
						<td>
							<router-link class="textlink" :title="project.client.name||'Ingen kunde'" :to="'project/'+project.key">{{project.name}}</router-link>
						</td>
						<td>
							<span v-if="project.invoice_ready">Klar</span>
							<span v-else>Ikke klar</span>
						</td>
						<td class="align-r">
							{{ project.payable_amount | money(0) }} kr.
						</td>
					</tr>				
				</table>
			</box>

		</div>
	</div><!--.grid-->


		
	<box label="BETA" v-if="show_beta_content">
		<p>[Graf+liste visning over min tid denne uge fordelt på opgaver og arbejdstype]<br/><br/></p>
		<p>
			<a class="textlink" href="https://trello.com/b/tAdvC4Vw/milk-studio" target="_blank">Link: Trello</a><br/>
			<a class="textlink" href="http://williampaix.com/projects/kia" target="_blank">Link: Kia v1</a><br/>
			<a class="textlink" href="https://console.firebase.google.com/u/0/project/kira-wpaix/database/data" target="_blank">Link: Firebase console</a><br/>
		</p>
		<img :src="gravatarurl('william.p.paix@gmail.com',150)" alt="">

	</box>

</div>
</template>

<script>

import jsmd5 from 'js-md5'
import moment from 'moment'
import auth from './../auth.js'
import mixins from '../mixins.js'
import helpers from '../helpers.js'
import './../components/generated_svg_icons/ionicons/android-time'
import './../components/generated_svg_icons/ionicons/android-arrow-forward'
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Avatar from '.././components/Avatar'
import Masonry from '.././components/Masonry'
import Comments from '.././components/Comments'

export default {
  name: 'home',
	mixins: [ mixins.db, mixins.generic ],
  globals: window.globals,
  components: { Box, Btn, Avatar, Masonry, Comments },
	data(){ return {
			//user: auth.getUser(),
			user: globals.user,
			globals: globals,

			ripple1: {
				color: 'red',
			},

	}},
	computed: {


		my_timelogs(){ return this.$store.getters['timelogs/my_timelogs'] },
		my_timelogs_this_week(){ return this.$store.getters['timelogs/my_timelogs_this_week'] },
		my_timelogs_today(){ return this.$store.getters['timelogs/my_timelogs_today'] },
		my_timelogs_yesterday(){ return this.$store.getters['timelogs/my_timelogs_yesterday'] },
		my_timelogs_today_hrs(){ return this.$store.getters['timelogs/my_timelogs_today_hrs'] },
		my_timelogs_yesterday_hrs(){ return this.$store.getters['timelogs/my_timelogs_yesterday_hrs'] },
		my_timelogs_this_week_hrs(){ return this.$store.getters['timelogs/my_timelogs_this_week_hrs'] },
		
		weekTimelogs_timespan(){

			var dates = helpers.moment_enumerateDaysBetweenDates( moment().subtract(6,'days'), moment().add(1,'days') )
			var output = []

			for( var i = 0; i < dates.length; i++ ) {
				var date = dates[i]

				var filters = {
					date_from_timestamp:   date.clone().add(-1,'days').unix(),
					date_to_timestamp:     date.clone().add(-1,'days').unix(),
					no_sorting: true,
				}

				var logs = this.$store.getters['timelogs/getFiltered'](filters, this.my_timelogs_this_week)
				var hours = this.$store.getters['timelogs/getTotalHours'](logs)

				output.push({
					date: date.utc(),
					hours_logged: hours,
					title: date.format('D/M'),
					dayno: date.day()
				})

			}

			return output

		},

		weekTimelogs_timespan_maxhours(){
			var o = 0
			for( var i = 0; i < this.weekTimelogs_timespan.length; i++ ) {
				var d = this.weekTimelogs_timespan[i]
				if( parseFloat(d.hours_logged) > o ) o = parseFloat(d.hours_logged)
			}
			return o
		},

		my_timelogs_today_invoicable_earning(){
			var dkk = 0
			if( !this.myTimelogsToday ) return dkk
			for( let timelog of this.myTimelogsToday ) {
				if( timelog.billable !== true ) continue
				let project = this.getOne('project', timelog.project_key )
				if( !project ) continue
				if( project.payment_model != 'time_expense' ) continue
				dkk += project.hour_rate * timelog.hours				
			}
			return dkk
		},

		allActiveProjects(){
            var projects = this.$store.getters['projects/getFiltered']({
				status: 'active',
			})
			for( let project of projects ) {
				project.client = this.$store.getters['clients/getOne'](project.client_key) || {name:'Ukendt'}
			}
			return projects
		},
		
		myActiveProjects(){
            var my_initials = this.$store.getters['users/get_initials'](this.my_user)
            var projects = this.$store.getters['projects/getFiltered']({
				tag_in: my_initials,
				status_not: 'finished',
			})
			for( let project of projects ) {
				project.client = this.$store.getters['clients/getOne'](project.client_key) || {name:'Ukendt'}
			}
			return projects
		},

		projects_invoice_ready(){
			var projects = this.$store.getters['projects/getFiltered']({
				tag_in: 'fakturaklar',
				status_not: 'finished',
			})
			projects = projects.filter((e)=>e.status!='draft')
			projects = projects.filter((e)=>e.status!='aborted')
			for( let project of projects ) {
				project.client = this.$store.getters['clients/getOne'](project.client_key) || {name:'Ukendt'}
			}
			return projects
		},
		
		projects_money_owed(){
			var projects = this.$store.getters['projects/getFiltered']({
				//tag_in: 'fakturaklar',
				status_not: 'finished',
			})
			projects = projects.filter((e)=>e.status!='draft')			
			projects = projects.filter((e)=>e.status!='aborted')			
			var output = []
			for( let project of projects ) {
				var payable_amount = this.$store.getters['projects/get_payable_amount'](project)
				project.client = this.$store.getters['clients/getOne'](project.client_key) || {name:'Ukendt'}
				if( !payable_amount ) continue
				project.payable_amount = payable_amount
				project.invoice_ready = ( (project.tags||'').toLowerCase().indexOf('fakturaklar') !== -1 )
				output.push(project)
			}
			output = output.filter((e)=>!e.invoice_ready)
			return output
		},


	}, // computed
	methods: {

		translateWorktype: helpers.translateWorktype,
		//getProject: helpers.getProject,
    	//getClient: helpers.getClient,
		delete_timelog: helpers.delete_timelog,
		//getClientKeyFromTimelog: helpers.getClientKeyFromTimelog,
		//getClientFromTimelog: helpers.getClientFromTimelog,

		getClientFromTimelog(timelog){
			var p = this.getOne('project',timelog.project_key)
			var c = this.getOne('client',p.client_key)
			return c
		},
		
		barHeight( a,b ){
			var css = {}

			if( a == undefined || isNaN(a) ) a = 0
			if( b == undefined || isNaN(b) ) b = 0

			var pct = parseInt(( a/b ) * 100 )

			if( pct < 0 ) pct = 0
			if( pct > 100 ) pct = 100

			css.height = pct + '%'
			return css
		},

		gravatarurl(email,radius){
			var baseurl = 'https://www.gravatar.com/avatar/'
			var md5_email = jsmd5(email)
			var size = '?s='+radius
			return baseurl+md5_email+size
		},

		editTimelog(timelog){
			globals.modal_timelog_edit.timelog = timelog
			globals.modal_timelog_edit.active = true
		},

		//getMyUserKeyByUID: helpers.getMyUserKeyByUID,
		triggerIconSignal: helpers.triggerIconSignal,


	},

	mounted(){


	},

	created(){

		eventBus.$emit('set_bgfade_img', 'white')

	},

}
</script>



// WEBPACK FOOTER //
// Home.vue?7f22b383